<template>
  <div>
    <div>
      <v-row :class="'mt-4'">
        <v-col cols="12" sm="6" md="6">
          <div>
            <v-btn outlined color="primary" class="mr-4" @click="updateDialogDocuments(true)" v-if="selectedFolder != null">Nuevo
              Documento</v-btn>
            <v-btn color="primary" @click="updateDialog(true)"
              v-if="selectedFolder === null || selectedFolder.legajo != null">Crear Carpeta</v-btn>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="6" class="justify-end align-end d-flex">
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" dense outlined></v-text-field>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col cols="12" md="12">
        <Breadcrumbs
          :navigationStack="navigationStack"
          :selectedFolder="selectedFolder"
          @reset-navigation="resetNavigation"
          @go-to-folder="goToFolder"
        />

        </v-col>
      </v-row>

      <ListFolder v-if="!selectedFolder" :folders="filteredFoldersView" @open-folder="openFolder"
        :loading_folders="loading_folders" @editItem="editItem" @deleteItem="deleteItem" :legajo_id="legajo_id" />

      <ListFile v-else :folderData="filteredFoldersView" @go-back="goBack" @open-folder="openFolder"
        @editItem="editItem" @deleteItemFile="deleteItemFile" @deleteItem="deleteItem"
        :loading_folders="loading_folders" :legajo_id="legajo_id" />

      <ModalFolder :modal_title="'Carpeta'" :formBtn="formBtn" :dialog="dialog" :service="service"
        @updateDialog="updateDialog" @loadList="loadList" :item="mainItem" @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        " :selectedFolder="selectedFolder" />


      <ModalAddDocuments :modal_title="'Subir Documentos'" :formBtn="formBtn" :dialog="dialog_documents"
        :service="documentLegajoService" @updateDialog="updateDialogDocuments" @loadList="loadList" :item="mainItem"
        @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        " :selectedFolder="selectedFolder" :legajo_id="legajo_id" />

      <!-- Borrar carpeta. -->
      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete"
        @deleteItemConfirm="deleteItemConfirm"
        :text="'¿Esta seguro que quiere eliminar la carpeta ' + mainItem.name + '?'"
        subtext="Al borrar se borrara los archivos dentro de esta carpeta" />

      <!-- Borrado de archivos .  -->
      <DialogDelete :dialog_delete="dialog_delete_file" @updateDialogDelete="updateDialogDeleteFile"
        @deleteItemConfirm="deleteItemConfirmFile"
        :text="'¿Esta seguro que quiere eliminar el archivo ' + mainItemFile.name + '?'" />
    </div>

  </div>
</template>

<script>
import ListFolder from '../../components/Folder/ListFolder.vue';
import ListFile from '../../components/Folder/ListFile.vue';
import ModalFolder from './LegajoDocuments/ModalFolder.vue';
import GenericMixin from '@/mixins/GenericMixin.vue';
import RolMixin from "@/mixins/RolMixin.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import ModalAddDocuments from './LegajoDocuments/ModalAddDocuments.vue';
import { documentLegajoService } from '../../libs/ws/documentLegajoService';
import { legajoService } from '../../libs/ws/legajoService';
import Breadcrumbs from '../../components/Folder/Breadcrumbs.vue';

export default {
  name: 'LegajoDocuments',
  mixins: [GenericMixin, RolMixin],
  components: {
    ListFolder,
    ListFile,
    ModalFolder,
    DialogDelete,
    ModalAddDocuments,
    Breadcrumbs
  },
  props: {
    loadFolders: {
      type: Function,
    },
    service: {
      type: Object
    },
    folders: {
      type: Array,
      required: true
    },
    loading_folders: {
      type: Boolean,
      default: false
    },
    legajo_id: {
      type: [Number, String],
      required: true
    }
  },
  watch: {
    legajo_id: {
      immediate: true,
      handler(newVal) {
        this.legajo_id = newVal;
      }
    },
    folders: {
      immediate: true,
      handler(newVal) {
        this.folders = newVal;
        // Buscar recursivamente la carpeta seleccionada

        if (this.selectedFolder) {
          const found = this.findFolderById(newVal, this.selectedFolder.id);
          this.selectedFolder = found || null;
          if (!found) {
            this.navigationStack = [];
          }
        }
      }
    }
  },
  data() {
    return {
      selectedFolder: null,
      navigationStack: [],
      documentLegajoService: documentLegajoService,
      legajoService: legajoService,
      mainItem: {
        name: '',
        color: '',
        legajo: this.legajo_id,
        folder_parent: null,
      },
      defaultItem: {
        name: '',
        color: '',
        legajo: this.legajo_id,
        folder_parent: null,
      },
      mainItemFile: {
        name: '',
      },
      defaultItemFile: {
        name: '',
      },
      dialog_documents: false,
      dialog_delete_file: false,
      search: '',
    }
  },
  computed: {
    filteredFoldersView() {
      const searchLower = this.search.toLowerCase();

      if (!this.selectedFolder) {
        // Si no hay carpeta seleccionada, devuelvo un array (para ListFolder)
        if (!this.search) {
          return this.folders;
        }
        return this.folders.filter(folder =>
          folder.name?.toLowerCase().includes(searchLower)
        );
      } else {
        // Si hay carpeta seleccionada, devuelvo el objeto con sub_folder y documents filtrados (para ListFile)
        if (!this.search) {
          return this.selectedFolder;
        }

        const filteredSubFolders = (this.selectedFolder.sub_folder || []).filter(
          folder => folder.name?.toLowerCase().includes(searchLower)
        );

        const filteredDocuments = (this.selectedFolder.documents || []).filter(
          doc => doc.name?.toLowerCase().includes(searchLower)
        );

        return {
          ...this.selectedFolder,
          sub_folder: filteredSubFolders,
          documents: filteredDocuments
        };
      }
    }
  },

  methods: {
    filterFolders(folders, searchTerm) {
      const searchLower = searchTerm.toLowerCase();

      const filterRecursive = (folder) => {
        const folderMatch = folder.name?.toLowerCase().includes(searchLower);
        const filteredDocuments = (folder.documents || []).filter(doc =>
          doc.name?.toLowerCase().includes(searchLower)
        );
        const filteredSubFolders = (folder.sub_folder || [])
          .map(filterRecursive)
          .filter(Boolean);

        if (folderMatch || filteredDocuments.length || filteredSubFolders.length) {
          return {
            ...folder,
            documents: filteredDocuments,
            sub_folder: filteredSubFolders
          };
        }

        return null;
      };

      return folders.map(filterRecursive).filter(Boolean);
    },
    findFolderById(folders, id) {
      for (const folder of folders) {
        if (folder.id === id) return folder;
        if (folder.sub_folder && folder.sub_folder.length) {
          const found = this.findFolderById(folder.sub_folder, id);
          if (found) return found;
        }
      }
      return null;
    },
    closeDocuments() {
      this.dialog_documents = false;
    },
    updateDialogDocuments(value) {
      this.dialog_documents = value;
      if (!value) {
        this.closeDocuments();
      }
    },
    async loadList() {
      // Recargar las carpetas
      await this.$emit("loadFolders");

    },
    updateDialogDeleteFile(value) {
      this.dialog_delete_file = value;
    },
    deleteItemFile(item) {
      this.deleteIndex = this.list.indexOf(item);
      this.mainItemFile = JSON.parse(JSON.stringify(item));
      this.deleteId = item.id;
      this.dialog_delete_file = true;
    },
    deleteItemConfirmFile() {
      this.delete(this.documentLegajoService);
      this.mainItemFile = JSON.parse(JSON.stringify(this.defaultItemFile));
      this.dialog_delete_file = false;
      this.loadList();
    },
    deleteItem(item) {
      this.deleteIndex = this.list.indexOf(item);
      this.mainItem = JSON.parse(JSON.stringify(item));
      this.deleteId = item.id;
      this.dialog_delete = true;
    },
    deleteItemConfirm() {
      this.delete_folder();
      this.mainItem = JSON.parse(JSON.stringify(this.defaultItem));
      this.dialog_delete = false;
      this.loadList();
    },
    delete_folder() {
      legajoService
        .delete_folder({ id: this.deleteId })
        .then((response) => {
          if (response.status === true) {
            this.$toast.success(response.msg, "OK");
            this.loadList();
          } else {
            if (Object.prototype.hasOwnProperty.call(response, "message")) {
              this.$toast.error(response.message, "Error");
            } else {
              this.$toast.error(response.msg, "Error");
            }
          }
        })
        .catch((e) => {
          console.log("service.filter error");
          console.log(e);
          this.$toast.error("Error exception", "Error");
        });
    },
    openFolder(folder) {
      if (this.selectedFolder) {
        this.navigationStack.push(this.selectedFolder)
      }
      this.selectedFolder = folder
    },
    goBack() {
      this.selectedFolder = this.navigationStack.pop() || null
    },
    goToFolder(index) {
      this.selectedFolder = this.navigationStack[index]
      this.navigationStack = this.navigationStack.slice(0, index)
    },
    resetNavigation() {
      this.selectedFolder = null
      this.navigationStack = []
    }
  }
}
</script>
